import HeroIllustration from '@/components/illustrations/HeroIllustration'
import { runSubmit, type ToolRunBinding } from './tool-run'
// Generated from the reference HTML (tools/aeo-page-auditor.nogate.html). It may carry hand edits since (SEO, accessibility, server-rendered data): edit it directly, never regenerate over it.
import Link from 'next/link'
import type { CSSProperties, ReactNode } from 'react'
import RefScript from '@/components/shell/RefScript'
import { GRADE_RANGE } from '@/lib/radar/scoring'

/** The reference page's own script, as written. */
const SCRIPT =
  "/* ---------- radar scope (canvas) ---------- */\n  const canvas = $('#scope'), ctx = canvas ? canvas.getContext('2d') : null;\n  if (canvas) {\n  const tags = $$('.scope__tag');\n  const degEl = $('#sweepDeg');\n  // blips: angle (deg), radius fraction, tag index\n  const blips = [\n    { a: 32,  r: .62, t: 0 }, // ChatGPT\n    { a: 118, r: .78, t: 1 }, // Claude\n    { a: 212, r: .50, t: 2 }, // Gemini\n    { a: 296, r: .70, t: 3 }, // Perplexity\n  ];\n  const ink = () => getComputedStyle(document.body).getPropertyValue('--ink').trim() || '#121212';\n  const accent = '#008dcc';\n  let W = 0, H = 0, dpr = 1, angle = 0, last = 0;\n  const resize = () => {\n    const rect = canvas.getBoundingClientRect();\n    dpr = Math.min(2, devicePixelRatio || 1);\n    W = Math.round(rect.width * dpr); H = Math.round(rect.height * dpr);\n    canvas.width = W; canvas.height = H;\n    // position tags\n    const R = rect.width / 2;\n    blips.forEach(b => {\n      const rad = (b.a - 90) * Math.PI / 180;\n      const x = R + Math.cos(rad) * R * b.r, y = R + Math.sin(rad) * R * b.r;\n      const el = tags[b.t]; if (!el) return;\n      el.style.left = x + 'px'; el.style.top = (y - 22) + 'px';\n    });\n  };\n  new ResizeObserver(resize).observe(canvas); resize();\n\n  const draw = (t) => {\n    const dt = last ? Math.min(50, t - last) : 16; last = t;\n    if (!reduced()) angle = (angle + dt * 0.045) % 360;\n    const cx = W / 2, cy = H / 2, R = Math.min(cx, cy) - 2 * dpr;\n    ctx.clearRect(0, 0, W, H);\n    ctx.save(); ctx.translate(cx, cy);\n    const col = ink();\n    // rings\n    ctx.lineWidth = 1 * dpr; ctx.strokeStyle = col; ctx.globalAlpha = .22;\n    [1, .75, .5, .25].forEach(f => { ctx.beginPath(); ctx.arc(0, 0, R * f, 0, Math.PI * 2); ctx.stroke(); });\n    // crosshair + ticks\n    ctx.globalAlpha = .18;\n    ctx.beginPath(); ctx.moveTo(-R, 0); ctx.lineTo(R, 0); ctx.moveTo(0, -R); ctx.lineTo(0, R); ctx.stroke();\n    ctx.globalAlpha = .35;\n    for (let d = 0; d < 360; d += 10) {\n      const rad = d * Math.PI / 180, len = d % 30 === 0 ? 10 : 5;\n      ctx.beginPath();\n      ctx.moveTo(Math.cos(rad) * (R - len * dpr), Math.sin(rad) * (R - len * dpr));\n      ctx.lineTo(Math.cos(rad) * R, Math.sin(rad) * R); ctx.stroke();\n    }\n    // sweep trail (conic)\n    const a0 = (angle - 90) * Math.PI / 180;\n    const grad = ctx.createConicGradient ? ctx.createConicGradient(a0 - Math.PI * 0.55, 0, 0) : null;\n    ctx.globalAlpha = 1;\n    if (grad) {\n      grad.addColorStop(0, 'rgba(0,141,204,0)');\n      grad.addColorStop(0.55, 'rgba(0,141,204,.40)');\n      grad.addColorStop(0.5501, 'rgba(0,141,204,0)');\n      grad.addColorStop(1, 'rgba(0,141,204,0)');\n      ctx.fillStyle = grad;\n      ctx.beginPath(); ctx.arc(0, 0, R, 0, Math.PI * 2); ctx.fill();\n    }\n    // sweep arm\n    ctx.strokeStyle = accent; ctx.lineWidth = 2 * dpr; ctx.globalAlpha = 1;\n    ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(Math.cos(a0) * R, Math.sin(a0) * R); ctx.stroke();\n    // blips\n    blips.forEach(b => {\n      const rad = (b.a - 90) * Math.PI / 180;\n      const x = Math.cos(rad) * R * b.r, y = Math.sin(rad) * R * b.r;\n      // how recently the sweep passed: 0..1 (1 = just now)\n      let diff = (angle - b.a + 360) % 360; const heat = Math.max(0, 1 - diff / 110);\n      ctx.beginPath(); ctx.arc(x, y, 3.5 * dpr, 0, Math.PI * 2);\n      ctx.fillStyle = col; ctx.globalAlpha = .35 + heat * .65; ctx.fill();\n      if (heat > 0) {\n        ctx.beginPath(); ctx.arc(x, y, (6 + (1 - heat) * 26) * dpr, 0, Math.PI * 2);\n        ctx.strokeStyle = accent; ctx.lineWidth = 1.2 * dpr; ctx.globalAlpha = heat * .9; ctx.stroke();\n      }\n      const el = tags[b.t]; if (el) el.classList.toggle('is-hot', heat > 0.15);\n    });\n    // center\n    ctx.globalAlpha = 1; ctx.fillStyle = col;\n    ctx.beginPath(); ctx.arc(0, 0, 3 * dpr, 0, Math.PI * 2); ctx.fill();\n    ctx.restore();\n    if (degEl) degEl.textContent = String(Math.round(angle)).padStart(3, '0') + '\u00b0';\n    requestAnimationFrame(draw);\n  };\n  requestAnimationFrame(draw);\n  }\n\n  \n;\n\n(() => {\n  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('reduce-motion');\n\n  // ---- instrument: adds .on when visible (CSS primitives animate), counts [data-num], Replay re-runs\n  const inst = document.getElementById('inst');\n  if (inst) {\n    const nums = [...inst.querySelectorAll('[data-num]')];\n    const count = () => nums.forEach(el => {\n      const end = parseFloat(el.dataset.num), suf = el.dataset.suffix || '', dec = +(el.dataset.dec || 0), dur = reduced() ? 1 : 1100, t0 = performance.now();\n      const s = t => { const p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3); el.textContent = (end * k).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(s); };\n      requestAnimationFrame(s);\n    });\n    const run = () => { inst.classList.remove('on'); void inst.offsetWidth; requestAnimationFrame(() => { inst.classList.add('on'); count(); }); };\n    new IntersectionObserver((es, io) => es.forEach(e => { if (e.isIntersecting) { setTimeout(run, 250); io.disconnect(); } }), { threshold: .35 }).observe(inst);\n    const rp = document.getElementById('instReplay'); if (rp) rp.addEventListener('click', run);\n  }\n\n  // ---- embed tabs + copy (badge page)\n  const tabs = document.getElementById('embedTabs');\n  if (tabs) {\n    tabs.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; [...tabs.children].forEach(x => x.setAttribute('aria-selected', String(x === b))); document.querySelectorAll('.snip [role=\"tabpanel\"]').forEach(p => p.classList.toggle('is-on', p.dataset.panel === b.dataset.tab)); });\n    document.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', async () => { try { await navigator.clipboard.writeText(b.dataset.copy); } catch (_) {} b.classList.add('is-done'); const t = b.innerHTML; b.lastChild.textContent = 'Copied'; setTimeout(() => { b.classList.remove('is-done'); b.innerHTML = t; }, 1400); }));\n  }\n\n  // ---- sub nav scrollspy + dark/accent adaptation (same as the service pages)\n  const sub = document.getElementById('subnav'); if (!sub) return;\n  const links = [...sub.querySelectorAll('a')], targets = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);\n  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(l => l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id)); }), { rootMargin: '-35% 0px -55% 0px' });\n  targets.forEach(t => io.observe(t));\n  const sheets = [...document.querySelectorAll('.sheet--ink, .sheet--accent')];\n  const last = document.getElementById(sub.dataset.last);\n  const band = () => {\n    const y = 72 + 26; let dark = false, accent = false;\n    for (const s of sheets) { const r = s.getBoundingClientRect(); if (r.top <= y && r.bottom > y) { accent = s.classList.contains('sheet--accent'); dark = !accent; break; } }\n    sub.classList.toggle('is-dark', dark); sub.classList.toggle('is-accent', accent);\n    if (last) sub.classList.toggle('is-gone', last.getBoundingClientRect().bottom < y);\n  };\n  addEventListener('scroll', band, { passive: true }); addEventListener('resize', band); band();\n})();\n"

export default function ToolAeoPageAuditorRef({
  run,
  form,
  output,
}: {
  run?: ToolRunBinding
  form?: ReactNode
  output?: ReactNode
}) {
  return (
    <>
      {' '}
      <div id='top'>
        {' '}
        <section
          className='sheet thero tpage'
          id='run'
          data-rail='Run'
          data-slot='hero'
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='hero__top'>
              {' '}
              <span className='eyebrow' data-slot='hero.eyebrow'>
                {'Tools / 03 · Page audit'}
              </span>{' '}
              <span className='mono' data-slot='hero.scope'>
                {'$5 one-time · 6 AEO categories · report opens here'}
              </span>{' '}
            </div>{' '}
            <div className='thero__grid'>
              {' '}
              <div className='thero__copy'>
                {' '}
                <div className='thero__tags' data-slot='hero.tags'>
                  <span className='chip chip--paid'>{'Paid · $5'}</span>
                  <span className='chip'>{'Page audit'}</span>
                </div>{' '}
                <h1 className='h-display h1' id='heroTitle' data-slot='hero.h1'>
                  <span className='word'>
                    <span>AEO</span>
                  </span>{' '}
                  <span className='word'>
                    <span>Page</span>
                  </span>{' '}
                  <span className='word'>
                    <span>Auditor:</span>
                  </span>{' '}
                  <span className='word'>
                    <span>score</span>
                  </span>{' '}
                  <span className='word'>
                    <span>any</span>
                  </span>{' '}
                  <span className='word'>
                    <span>page</span>
                  </span>{' '}
                  <span className='word'>
                    <span>for</span>
                  </span>{' '}
                  <span className='serif'>
                    <span className='word'>
                      <span>AI</span>
                    </span>{' '}
                    <span className='word'>
                      <span>answer</span>
                    </span>{' '}
                    <span className='word'>
                      <span>engines.</span>
                    </span>
                  </span>
                </h1>{' '}
                <p className='lede' data-reveal='' data-slot='hero.sub'>
                  {
                    'Score how extractable your page is for AI answer engines across 6 AEO categories.'
                  }
                </p>{' '}
                <div data-reveal='fade'>
                  {form ?? (
                    <form
                      className='run'
                      id='runForm'
                      data-slot='hero.form'
                      noValidate
                      onSubmit={runSubmit(run)}
                    >
                      {' '}
                      <label className='run__field'>
                        <span>{'Page URL'}</span>
                        <input
                          type='text'
                          name='f0'
                          placeholder='Enter a page URL (e.g. example.com/blog/my-post)'
                          autoComplete='off'
                          inputMode='url'
                          value={run ? (run.values[0] ?? '') : undefined}
                          onChange={
                            run
                              ? e => run.onChange(0, e.target.value)
                              : undefined
                          }
                          onBlur={
                            run?.onBlur ? () => run.onBlur?.(0) : undefined
                          }
                          disabled={run?.loading}
                        />
                      </label>{' '}
                      <div className='run__actions'>
                        <button
                          className='btn btn--accent'
                          type='submit'
                          disabled={run?.loading}
                        >
                          {'Audit Page'}
                          <svg
                            className='arrow'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='1.8'
                          >
                            <path d='M5 12h14M13 6l6 6-6 6' />
                          </svg>
                        </button>
                        <button
                          type='button'
                          className='btn btn--ghost btn--sm'
                          data-example='pixelmojo.io/blogs'
                          onClick={run?.onExample}
                        >
                          {'Try pixelmojo.io/blogs'}
                        </button>
                      </div>{' '}
                      <p className='run__note' data-slot='hero.note'>
                        <i />
                        <span>{'$5 one-time · report opens here'}</span>
                      </p>{' '}
                      {run?.error ? (
                        <p className='run__note run__error' role='alert'>
                          <i />
                          {run.error}
                        </p>
                      ) : null}
                    </form>
                  )}
                </div>{' '}
              </div>{' '}
              <aside
                className='inst inst--art'
                id='inst'
                data-reveal='fade'
                data-slot='hero.instrument'
                data-glyph='aeo'
              >
                {' '}
                <div className='inst__bar'>
                  <b>{'AEO Page Auditor'}</b>
                  <span className='inst__state'>
                    <i />
                    {'Preview'}
                  </span>
                </div>{' '}
                <div className='inst__canvas'>
                  <HeroIllustration variant='aeo'>
                    <rect
                      x='28'
                      y='14'
                      width='196'
                      height='192'
                      rx='10'
                      className='soft'
                    />
                    <path d='M48 40h104' className='ln thick' />
                    <path d='M48 58h84' className='ln' />
                    <path d='M48 76h140' className='ln thin' />
                    <path d='M48 88h118' className='ln thin' />
                    <rect
                      x='42'
                      y='68'
                      width='152'
                      height='24'
                      rx='4'
                      className='gp'
                      fill='var(--yellow)'
                      opacity='.32'
                      style={{ '--i': '1' } as CSSProperties}
                    />
                    <path
                      d='M196 80h30'
                      className='gl'
                      stroke='var(--line-strong)'
                      strokeWidth='1'
                      strokeDasharray='3 3'
                      style={{ '--l': '30', '--i': '2' } as CSSProperties}
                    />
                    <g className='gf' style={{ '--i': '2' } as CSSProperties}>
                      <rect
                        x='228'
                        y='68'
                        width='104'
                        height='24'
                        rx='6'
                        className='frame'
                      />
                      <text x='280' y='83' textAnchor='middle' className='lab'>
                        {'SPEAKABLE'}
                      </text>
                    </g>
                    <path d='M48 100h84' className='ln' />
                    <path d='M48 118h140' className='ln thin' />
                    <path d='M48 130h118' className='ln thin' />
                    <rect
                      x='42'
                      y='110'
                      width='152'
                      height='24'
                      rx='4'
                      className='gp'
                      fill='var(--yellow)'
                      opacity='.32'
                      style={{ '--i': '3' } as CSSProperties}
                    />
                    <path
                      d='M196 122h30'
                      className='gl'
                      stroke='var(--line-strong)'
                      strokeWidth='1'
                      strokeDasharray='3 3'
                      style={{ '--l': '30', '--i': '4' } as CSSProperties}
                    />
                    <g className='gf' style={{ '--i': '4' } as CSSProperties}>
                      <rect
                        x='228'
                        y='110'
                        width='104'
                        height='24'
                        rx='6'
                        className='frame'
                      />
                      <text x='280' y='125' textAnchor='middle' className='lab'>
                        {'DEFINITION'}
                      </text>
                    </g>
                    <path d='M48 142h84' className='ln' />
                    <path
                      d='M48 160h140M48 172h140M48 184h140'
                      className='ln thin'
                    />
                    <path d='M94 154v36M140 154v36' className='ln thin' />
                    <rect
                      x='42'
                      y='152'
                      width='152'
                      height='40'
                      rx='4'
                      className='gp'
                      fill='var(--yellow)'
                      opacity='.32'
                      style={{ '--i': '5' } as CSSProperties}
                    />
                    <path
                      d='M196 164h30'
                      className='gl'
                      stroke='var(--line-strong)'
                      strokeWidth='1'
                      strokeDasharray='3 3'
                      style={{ '--l': '30', '--i': '6' } as CSSProperties}
                    />
                    <g className='gf' style={{ '--i': '6' } as CSSProperties}>
                      <rect
                        x='228'
                        y='152'
                        width='104'
                        height='24'
                        rx='6'
                        className='frame'
                      />
                      <text x='280' y='167' textAnchor='middle' className='lab'>
                        {'TABLE'}
                      </text>
                    </g>
                    <g className='gp' style={{ '--i': '8' } as CSSProperties}>
                      <rect
                        x='228'
                        y='184'
                        width='104'
                        height='28'
                        rx='8'
                        fill='var(--radar)'
                      />
                      <text
                        x='280'
                        y='203'
                        textAnchor='middle'
                        className='lab'
                        fill='#fff'
                        style={
                          { opacity: '1', fontWeight: '600' } as CSSProperties
                        }
                      >
                        {'B · 78/100'}
                      </text>
                    </g>
                    <text x='28' y='216' textAnchor='start' className='lab'>
                      {'6 CATEGORIES · 100 PTS'}
                    </text>
                  </HeroIllustration>
                </div>{' '}
                <div className='inst__foot'>
                  <span data-slot='hero.inst_note'>
                    {'Illustrative · six categories · 100 pts'}
                  </span>
                  <button
                    className='inst__replay'
                    type='button'
                    id='instReplay'
                  >
                    {'Replay '}
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M4 12a8 8 0 1 0 2.3-5.7M4 4v5h5' />
                    </svg>
                  </button>
                </div>{' '}
              </aside>{' '}
            </div>{' '}
          </div>{' '}
          {output ? (
            <div className='container tool-output'>{output}</div>
          ) : null}
        </section>{' '}
        <div className='subnav' id='subnav' data-last='related'>
          {' '}
          <div className='container subnav__inner'>
            {' '}
            <a href='#about'>
              <i />
              {'What it does'}
            </a>
            <a href='#checks'>
              <i />
              {'What we check'}
            </a>
            <a href='#scoring'>
              <i />
              {'Scoring'}
            </a>
            <a href='#research'>
              <i />
              {'Research'}
            </a>
            <a href='#related'>
              <i />
              {'Related tools'}
            </a>{' '}
            <span className='subnav__spacer' />{' '}
            <span className='mono'>
              {'$5 one-time · 6 AEO categories · report opens here'}
            </span>{' '}
          </div>{' '}
        </div>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='about'
          data-rail='What it does'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head' data-reveal=''>
              {' '}
              <span className='eyebrow'>{'01 / What it does'}</span>{' '}
              <h2 className='h-display h2' data-slot='kicker'>
                {'Readable is not the same as '}
                <span className='serif'>{'extractable.'}</span>
              </h2>{' '}
            </div>{' '}
            <div className='about'>
              {' '}
              <div className='about__copy' data-reveal='' data-slot='intro'>
                <p className='lede'>
                  {
                    'AI search engines like ChatGPT, Perplexity, and Google AI Overviews do not just read your content. They extract specific data points, definitions, and structured elements. This tool scores how extractable your page is across 6 AEO categories.'
                  }
                </p>
              </div>{' '}
              <div
                className='facts facts--tool'
                data-reveal='fade'
                data-slot='facts'
              >
                <div className='fact'>
                  <span>{'Input'}</span>
                  <b>{'One page URL'}</b>
                </div>
                <div className='fact'>
                  <span>{'Output'}</span>
                  <b>{'0-100 AEO score, A-F grade, per-category fixes'}</b>
                </div>
                <div className='fact'>
                  <span>{'Price'}</span>
                  <b>{'$5 one-time · report opens on this page'}</b>
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--ink sheet--pad'
          id='checks'
          data-rail='What we check'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head sec-head--split' data-reveal=''>
              {' '}
              <div style={{ display: 'grid', gap: '22px' } as CSSProperties}>
                <span className='eyebrow'>{'02 / What we check'}</span>
                <h2 className='h-display h2' data-slot='checks.title'>
                  {'What we '}
                  <span className='serif'>{'check.'}</span>
                </h2>
              </div>{' '}
              <p className='lede'>
                {
                  '6 checks, each with a plain-English reason it matters. Every one maps to a line in the report.'
                }
              </p>{' '}
            </div>{' '}
            <div
              className='wgrid reveal-stagger'
              data-reveal=''
              data-slot='checks.items'
              data-n='6'
            >
              <div className='wcard'>
                <span className='mono'>
                  <span>{'01'}</span>
                  <span>{'AEO Page Auditor'}</span>
                </span>
                <h3>{'Speakable Schema'}</h3>
                <p>
                  {
                    'Does your Article JSON-LD include SpeakableSpecification? Do the CSS selectors target real page elements?'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'02'}</span>
                  <span>{'AEO Page Auditor'}</span>
                </span>
                <h3>{'Answer-First Structure'}</h3>
                <p>
                  {
                    'Single H1, valid heading hierarchy, question-format H2s, and concise definition paragraphs under each heading.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'03'}</span>
                  <span>{'AEO Page Auditor'}</span>
                </span>
                <h3>{'Structured Data Quality'}</h3>
                <p>
                  {
                    'Article completeness (author, dateModified, publisher), Organization sameAs, FAQPage, BreadcrumbList, and entity-linked knowsAbout.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'04'}</span>
                  <span>{'AEO Page Auditor'}</span>
                </span>
                <h3>{'Data Extractability'}</h3>
                <p>
                  {
                    'HTML tables, ordered lists, StatBlock data callouts, and external source citations that AI engines can directly extract.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'05'}</span>
                  <span>{'AEO Page Auditor'}</span>
                </span>
                <h3>{'Content Freshness'}</h3>
                <p>
                  {
                    'dateModified in schema, Last-Modified HTTP headers, and recency signals that affect AI re-crawl frequency.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'06'}</span>
                  <span>{'AEO Page Auditor'}</span>
                </span>
                <h3>{'Entity Authority'}</h3>
                <p>
                  {
                    'Organization sameAs links, Person credentials, DefinedTerm references, and OpenGraph/Twitter Card meta tags.'
                  }
                </p>
              </div>
              <div className='wcard wcard--fill' aria-hidden='true'>
                <b>{'6'}</b>
                <span>{'checks in every report'}</span>
              </div>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='scoring'
          data-rail='Scoring'
          style={
            {
              borderRadius: 'var(--radius-sheet) var(--radius-sheet) 0 0',
              marginTop: 'calc(var(--radius-sheet) * -1)',
              paddingBottom: 'var(--section)',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head' data-reveal=''>
              {' '}
              <span className='eyebrow'>{'03 / Scoring'}</span>{' '}
              <h2 className='h-display h2' data-slot='scoring.title'>
                {'How We Score '}
                <span className='serif'>{'(100 Points Total)'}</span>
              </h2>{' '}
            </div>{' '}
            <div className='score'>
              {' '}
              <div className='score__label' data-reveal=''>
                {' '}
                <div className='score__total'>
                  <span data-count='100'>{'100'}</span>
                  <small>{'points'}</small>
                </div>{' '}
                <p data-slot='scoring.intro'>
                  {
                    'Your AEO score measures how extractable your page is for AI search engines. Each category targets a specific aspect of answer engine citation readiness. For what a good score looks like against real audit data, read '
                  }
                  <Link href='/blogs/aeo-score-explained-checkers-grades-improvement'>
                    {'AEO Score Explained'}
                  </Link>
                  {'.'}
                </p>{' '}
              </div>{' '}
              <div
                className='srows'
                data-reveal='fade'
                data-slot='scoring.items'
              >
                <div className='srow'>
                  <span className='srow__i'>{'01'}</span>
                  <div>
                    <div className='srow__n'>{'Speakable Schema'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '15%' } as CSSProperties} />
                    </div>
                  </div>
                  <div className='srow__p'>
                    <span data-count='15'>{'15'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'02'}</span>
                  <div>
                    <div className='srow__n'>{'Answer-First Structure'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '20%' } as CSSProperties} />
                    </div>
                  </div>
                  <div className='srow__p'>
                    <span data-count='20'>{'20'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'03'}</span>
                  <div>
                    <div className='srow__n'>{'Structured Data Quality'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '25%' } as CSSProperties} />
                    </div>
                  </div>
                  <div className='srow__p'>
                    <span data-count='25'>{'25'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'04'}</span>
                  <div>
                    <div className='srow__n'>{'Data Extractability'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '20%' } as CSSProperties} />
                    </div>
                  </div>
                  <div className='srow__p'>
                    <span data-count='20'>{'20'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'05'}</span>
                  <div>
                    <div className='srow__n'>{'Content Freshness'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '10%' } as CSSProperties} />
                    </div>
                  </div>
                  <div className='srow__p'>
                    <span data-count='10'>{'10'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'06'}</span>
                  <div>
                    <div className='srow__n'>{'Entity Authority'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '10%' } as CSSProperties} />
                    </div>
                  </div>
                  <div className='srow__p'>
                    <span data-count='10'>{'10'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
              </div>{' '}
            </div>{' '}
            <div
              className='grades'
              data-reveal='fade'
              data-slot='scoring.grades'
            >
              <div className='grade' data-g='A'>
                <b>{'A'}</b>
                <span>{GRADE_RANGE.A}</span>
              </div>
              <div className='grade' data-g='B'>
                <b>{'B'}</b>
                <span>{GRADE_RANGE.B}</span>
              </div>
              <div className='grade' data-g='C'>
                <b>{'C'}</b>
                <span>{GRADE_RANGE.C}</span>
              </div>
              <div className='grade' data-g='D'>
                <b>{'D'}</b>
                <span>{GRADE_RANGE.D}</span>
              </div>
              <div className='grade' data-g='F'>
                <b>{'F'}</b>
                <span>{GRADE_RANGE.F}</span>
              </div>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='research'
          data-rail='Research'
          style={
            {
              '--bg': 'var(--paper-2)',
              paddingBottom: 'var(--section)',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='research'>
              {' '}
              <div
                className='research__copy'
                data-reveal=''
                data-slot='research.copy'
              >
                {' '}
                <span className='eyebrow'>{'04 / Research'}</span>{' '}
                <h2
                  className='h-display h3'
                  style={
                    { fontSize: 'clamp(30px,3.6vw,52px)' } as CSSProperties
                  }
                >
                  {'Built on our own research'}
                </h2>{' '}
                <p>
                  {
                    'The scoring rubric comes from auditing our own posts for answer engines and watching which ones got cited. Every criterion maps to something we changed on pixelmojo.io and measured.'
                  }
                </p>{' '}
              </div>{' '}
              <div data-reveal='fade'>
                <div className='reading' data-slot='research.links'>
                  <Link href='/blogs/aeo-score-explained-checkers-grades-improvement'>
                    <span className='mono'>{'Scores'}</span>
                    <b>
                      {'AEO Score Explained: Checkers, Grades, Improvement'}
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/knowledge-graph-llm-visibility-real-data'>
                    <span className='mono'>{'Structured data'}</span>
                    <b>
                      {'How We Built a Knowledge Graph That LLMs Actually Cite'}
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/geo-playbook-get-cited-chatgpt-perplexity-claude'>
                    <span className='mono'>{'GEO'}</span>
                    <b>{'The GEO Playbook'}</b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/seo-vs-geo-vs-aeo-guide-2026'>
                    <span className='mono'>{'Strategy'}</span>
                    <b>
                      {
                        'SEO vs AEO vs GEO: From Ranking in Search to Becoming the Recommended Brand'
                      }
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage'
          id='related'
          data-rail='Related tools'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container rel'>
            {' '}
            <div className='sec-head sec-head--split' data-reveal=''>
              {' '}
              <div style={{ display: 'grid', gap: '22px' } as CSSProperties}>
                <span className='eyebrow'>{'05 / Related free tools'}</span>
                <h2 className='h-display h2' data-slot='related.title'>
                  {'Related free '}
                  <span className='serif'>{'tools.'}</span>
                </h2>
              </div>{' '}
              <Link className='btn btn--ghost' href='/tools'>
                {'Browse all tools'}
                <svg
                  className='arrow'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.8'
                >
                  <path d='M5 12h14M13 6l6 6-6 6' />
                </svg>
              </Link>{' '}
            </div>{' '}
            <div
              className='tgrid reveal-stagger'
              data-reveal=''
              data-slot='related.items'
              data-n='4'
            >
              <Link className='tcard' href='/tools/open-graph-auditor'>
                <div className='tcard__top'>
                  <span>{'Shareability'}</span>
                </div>
                <h3>{'AI Open Graph Auditor'}</h3>
                <p>
                  {
                    'Check how your page renders in AI assistants and share previews.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/ai-crawl-checker'>
                <div className='tcard__top'>
                  <span>{'17 bots'}</span>
                </div>
                <h3>{'AI Crawl Checker'}</h3>
                <p>
                  {
                    'Check access policies for 17 search, retrieval, training, and other crawlers.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/ai-readiness-score'>
                <div className='tcard__top'>
                  <span>{'Unified'}</span>
                </div>
                <h3>{'AI Readiness Score'}</h3>
                <p>{'See your overall AI-search readiness in one score.'}</p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/llms-txt-validator'>
                <div className='tcard__top'>
                  <span>{'Deep scan'}</span>
                </div>
                <h3>{'llms.txt Validator'}</h3>
                <p>
                  {
                    'Deep-scan your llms.txt against the emerging specification.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--ink sheet--pad'
          id='radar'
          data-rail='Radar'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container radarband'>
            {' '}
            <div
              data-reveal=''
              style={{ display: 'grid', gap: '22px' } as CSSProperties}
            >
              {' '}
              <span className='eyebrow'>{'Radar'}</span>{' '}
              <h2 className='h-display h2'>
                {'Want the full picture across four '}
                <span className='serif'>{'AI engines?'}</span>
              </h2>{' '}
              <p className='lede'>
                {
                  'Radar orchestrates 13 AI visibility audits in staged batches: crawl access, llms.txt, structured data, brand citations, and more. It then surfaces cross-tool conflicts and ships a prioritized action plan for your domain.'
                }
              </p>{' '}
              <div className='hero__cta'>
                {' '}
                <Link className='btn btn--accent' href='/platform#free-audit'>
                  {'Get My Free Snapshot '}
                  <svg
                    className='arrow'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                  >
                    <path d='M5 12h14M13 6l6 6-6 6' />
                  </svg>
                </Link>{' '}
                <Link
                  className='btn btn--ghost'
                  href='/services/ai-visibility-strategy'
                >
                  {'Or book a strategy session'}
                </Link>{' '}
              </div>{' '}
            </div>{' '}
            <div
              className='scope'
              data-reveal='fade'
              aria-label='Radar sweep across four AI engines'
            >
              {' '}
              <canvas id='scope' />{' '}
              <div className='scope__tags' aria-hidden='true'>
                {' '}
                <span className='scope__tag' data-tag='0'>
                  {'ChatGPT'}
                </span>
                <span className='scope__tag' data-tag='1'>
                  {'Claude'}
                </span>
                <span className='scope__tag' data-tag='2'>
                  {'Gemini'}
                </span>
                <span className='scope__tag' data-tag='3'>
                  {'Perplexity'}
                </span>{' '}
              </div>{' '}
              <div className='scope__meta'>
                {'Sweep · '}
                <b id='sweepDeg'>{'000°'}</b>
                {' · 13 checks · one pass'}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--accent cta sheet--pad'
          id='start'
          data-rail='Start'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='cta__ghost' aria-hidden='true'>
            {'$5'}
          </div>{' '}
          <div className='container cta__inner'>
            {' '}
            <div
              data-reveal=''
              style={{ display: 'grid', gap: '22px' } as CSSProperties}
            >
              {' '}
              <span className='eyebrow'>{'Start now'}</span>{' '}
              <h2 className='h-display' data-slot='cta.title'>
                {'Run it on your page. See what AI '}
                <span className='serif'>{'can read.'}</span>
              </h2>{' '}
              <p
                className='lede'
                style={{ color: 'rgba(18,18,18,.72)' } as CSSProperties}
                data-slot='cta.text'
              >
                {
                  'One-time $5, no subscription, report on this page. When you want the whole picture, Radar runs all 13 audits in one pass.'
                }
              </p>{' '}
            </div>{' '}
            <div className='hero__cta' data-reveal='fade'>
              <a className='btn' href='#run'>
                {'Audit Page'}
                <svg
                  className='arrow'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.8'
                >
                  <path d='M5 12h14M13 6l6 6-6 6' />
                </svg>
              </a>
              <Link className='btn btn--ghost' href='/tools'>
                {'Browse all tools'}
              </Link>
            </div>{' '}
          </div>{' '}
        </section>{' '}
      </div>{' '}
      <RefScript code={SCRIPT} />
    </>
  )
}
